import actions from '@/auth/constants';
import withDraft from '@/utils/draftHelper';
import { defaultRole } from './state';

const initializing = withDraft((draft) => {
  draft.initializing = true;
  draft.initialized = false;
});

const initialized = withDraft((draft) => {
  draft.initializing = false;
  draft.initialized = true;
});

const acquiredIdTokenSuccess = withDraft((draft, action) => { draft.idToken = action.payload; });

const acquiredAccessTokenSuccess = withDraft((draft, action) => { draft.accessToken = action.payload; });

const acquiredAccessTokenError = withDraft((draft) => { draft.accessToken = null; });

const loginSuccess = withDraft((draft) => {
  draft.role = defaultRole();
  draft.role.isLoading = true;
});

const resetLogin = withDraft((draft) => {
  draft.idToken = null;
  draft.accessToken = null;
  draft.currentUser = null;
});

const authenticatedStateChanged = withDraft((draft, action) => {
  draft.state = action.payload;
});

export default {
  [actions.ACQUIRED_ACCESS_TOKEN_ERROR]: acquiredAccessTokenError,
  [actions.ACQUIRED_ACCESS_TOKEN_SUCCESS]: acquiredAccessTokenSuccess,
  [actions.ACQUIRED_ID_TOKEN_ERROR]: resetLogin,
  [actions.ACQUIRED_ID_TOKEN_SUCCESS]: acquiredIdTokenSuccess,
  [actions.AUTHENTICATED_STATE_CHANGED]: authenticatedStateChanged,
  [actions.INITIALIZED]: initialized,
  [actions.INITIALIZING]: initializing,
  [actions.LOGIN_ERROR]: resetLogin,
  [actions.LOGIN_SUCCESS]: loginSuccess,
  [actions.LOGOUT_SUCCESS]: resetLogin,
};
